import { useEffect, useRef, useState } from "react";
import useSingleJobSkus from "../zustandStores/singleJobSkus";
import useCreditProfileStore from "../zustandStores/userCreditProfileStore";
import usePremiumJobCreditsBreakUp from "./premiumJobCreditsBreakUp";
import { zustandFetchStates } from "../services/constants";

type JobPlan = "PREMIUM" | "BASIC";
interface checkSufficientCreditsParams {
  jobId?: number;
  categoryId?: number;
  cityId?: string;
  jobPlan?: JobPlan;
}

const useCheckSufficientCredits = ({
  jobId,
  categoryId,
  cityId,
  jobPlan = "PREMIUM"
}: checkSufficientCreditsParams): boolean | null => {
  const { data } = useCreditProfileStore(state => ({
    data: state.data
  }));
  const { totalAvailableCredits } = data;
  const { fetchState } = useSingleJobSkus((state: any) => ({
    fetchState: state.fetchState
  }));
  const { discountedCredits } = usePremiumJobCreditsBreakUp({
    jobId,
    categoryId,
    cityId,
    jobPlan
  });
  const [isSufficientCredits, setIsSufficientCredits] = useState<
    boolean | null
  >(null);
  useEffect(() => {
    if (fetchState === zustandFetchStates.SUCCESS) {
      setIsSufficientCredits(totalAvailableCredits >= discountedCredits);
    } else {
      setIsSufficientCredits(null);
    }
  }, [fetchState]);
  return isSufficientCredits;
};

export default useCheckSufficientCredits;
